// initial state
import * as base from './base.js'
const baseName = '/admin/logisticsType'

const logisticsTypeList = baseName + '/list'
const logisticsTypeAdd = baseName + '/add'
const logisticsTypeEdit = baseName + '/edit'


const obj = base.setBaseUrl('logisticsType', baseName)
const obj1 = base.setBaseUrl('logisticsList', logisticsTypeList)
const obj2 = base.setBaseUrl('logisticsTypeAdd', logisticsTypeAdd)
const obj3 = base.setBaseUrl('logisticsTypeEdit', logisticsTypeEdit)


const a = Object.assign(obj, obj1, obj2, obj3,{ logisticsTypeList, logisticsTypeAdd,logisticsTypeEdit})
export default a
